import { withStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import Carousel from 'react-material-ui-carousel';
import DocumentPreview from './component/preview.thumbnail';
import PdfReview from './component/pdf.preview';
import { Grid, IconButton, Typography } from '@material-ui/core';
import { CloudDownload as DownloadIcon, InsertDriveFile as FileIcon } from '@material-ui/icons';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { config } from '../../remote-api/api/configuration';

const useStyles = theme => ({
  navButtonsWrapperProps: {
    top: '50%',
    height: '12%',
  },
});
const RenderPreview = (document, baseDocumentURL) => {
  const { docFormat, documentName } = document;
  const completeURL = `${baseDocumentURL}${documentName}`;

  const [img, setImg] = useState();

  useEffect(() => {
    const fetchImg = async () => {
      try {
        const res = await fetch(completeURL, {
          headers: {
            Authorization: `Bearer ${window.getToken()}`,
          },
        });

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        let file = await res.blob();
        setImg(URL.createObjectURL(file));
      } catch (error) {
        alert('Failed to fetch the image');
        // Handle the error (e.g., display a fallback image or show an error message)
      }
    };
    fetchImg();
  }, []);


  if (docFormat.split('/')[0] === 'image') {
    // if (docFormat === 'image/png') {
    return (
      <img
        src={img} // Complete URL for images
        alt="Document Thumbnail"
        style={{
          width: '100%',
          height: '100%',
          display: 'block',
          borderRadius: '8px',
          objectFit: 'cover',
        }}
      />
    );
  } else if (docFormat === 'application/pdf') {
    return <PdfReview url={completeURL} />;
  } else {
    return null;
  }
};

function useQuery1() {
  return new URLSearchParams(useLocation().search);
}
const SliderComponent = ({ items, classes }) => {
  const query = useQuery1();
  const { id } = useParams();
  let preId = query.get('preId');
  if (!preId) {
    preId = id.split('-')[1];
  }
  const baseDocumentURL = `${config.rootUrl}claim-query-service/v1/preauths/${preId}/docs/`;
  // const baseDocumentURL = `https://api.eoxegen.com/claim-query-service/v1/preauths/${preId}/docs/`;
  return (
    <div>
      <Carousel
        autoPlay={false}
        indicators={false}
        navButtonsAlwaysVisible={true}
        navButtonsWrapperProps={{
          className: classes.navButtonsWrapperProps,
        }}>
        {items?.map((item, i) => {
          return (
            // <DocumentPreview documents={item} preAuthId={i} />
            <Grid item key={item.id}>
              <div style={{ position: 'relative', borderRadius: '6px', border: '1px solid rgba(0, 0, 0, 0.1)' }}>
                {RenderPreview(item, baseDocumentURL)}
                <a href={`${baseDocumentURL}${item.documentName}`} download>
                  <IconButton
                    style={{
                      position: 'absolute',
                      top: 1,
                      right: 1,
                      padding: '4px',
                      color: '#fff',
                      backgroundColor: 'rgba(0, 0, 0, 0.2)',
                      transition: 'background-color 0.3s',
                    }}
                    // Add onMouseEnter and onMouseLeave to handle hover effect
                    onMouseEnter={e => (e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.4)')}
                    onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.2)')}>
                    <DownloadIcon />
                  </IconButton>
                </a>
              </div>
              <div style={{ textAlign: 'left', marginTop: '8px' }}>
                <Typography
                  variant="subtitle2"
                  style={{ maxWidth: '100px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                  title={document.documentName}>
                  {item.documentOriginalName}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {item.documentType}
                </Typography>
              </div>
            </Grid>
          );
        })}
      </Carousel>
    </div>
  );
};

export default withStyles(useStyles)(SliderComponent);
